import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * A list of (optionally clickable) items with consistent styling and action buttons.
 */
import './List.css';
import { useContext } from "react";
import { chevronForwardIcon } from "../icons";
import { getKeyHandler } from "./FlowForm";
import Icon from "../widgets/Icon";
import Checkbox from '../widgets/Checkbox';
import { goTo, RouterContext } from '../router/Router';
export const List = ({ children, className }) => {
    return _jsx("ul", { className: `tList ${className !== null && className !== void 0 ? className : ''}`, children: children });
};
function focusRelative(el, relativePosition) {
    let current = el;
    for (let i = 0; i < Math.abs(relativePosition); i++) {
        if (relativePosition < 0) {
            const c = current.previousElementSibling;
            if (!c || !c.classList.contains('listItem'))
                break;
            current = c;
        }
        else {
            const c = current.nextElementSibling;
            if (!c || !c.classList.contains('listItem'))
                break;
            current = c;
        }
        console.log('current', current);
    }
    current === null || current === void 0 ? void 0 : current.focus();
    return current !== el;
}
export const ListItem = ({ children, buttons, className, onClick, href, selected, disabled = false, focussable = 'flow', childDirection = 'column' }) => {
    const routerCtx = useContext(RouterContext);
    const handleKeyDown = disabled ? undefined : getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        onAction: onClick,
        sidewaysBehaviour: 'both',
        overrideHandlers: {
            'PageUp': (el) => { focusRelative(el, -15); return true; },
            'PageDown': (el) => { focusRelative(el, 15); return true; },
        },
    });
    const clickable = !!onClick || !!href;
    if (href)
        return _jsxs("a", { href: href, tabIndex: (!clickable) || disabled ? undefined : 0, className: `listItem ${className !== null && className !== void 0 ? className : ''} ${disabled ? 'disabled' : 'enabled'}${!disabled && focussable == 'flow' ? ' flowFocussable' : ''}${selected ? ' selected' : ''}${clickable ? ' clickable' : ''}`, onClick: disabled ? undefined : (ev) => { ev.preventDefault(); goTo(routerCtx, href, 'push'); }, onKeyDown: handleKeyDown, children: [_jsx("div", { className: `childContainer ${childDirection}`, children: children }), buttons, clickable && _jsx(Icon, { icon: chevronForwardIcon })] });
    else
        return _jsxs("li", { tabIndex: (!clickable) || disabled ? undefined : 0, className: `listItem ${className !== null && className !== void 0 ? className : ''} ${disabled ? 'disabled' : 'enabled'}${!disabled && focussable == 'flow' ? ' flowFocussable' : ''}${selected ? ' selected' : ''}${clickable ? ' clickable' : ''}`, onClick: disabled ? undefined : (ev) => { ev.preventDefault(); onClick === null || onClick === void 0 ? void 0 : onClick(!selected); }, onKeyDown: handleKeyDown, children: [_jsx("div", { className: `childContainer ${childDirection}`, children: children }), buttons, clickable && _jsx(Icon, { icon: chevronForwardIcon })] });
};
export const ListCheckboxItem = ({ children, buttons, className, onClick, onDelete, selected, childDirection = 'column' }) => {
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        onAction: () => onClick === null || onClick === void 0 ? void 0 : onClick(!selected),
        onDelete
    });
    return _jsxs("li", { tabIndex: 0, className: `listItem checkbox ${className !== null && className !== void 0 ? className : ''} enabled flowFocussable clickable`, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(!selected), onKeyDown: handleKeyDown, children: [_jsx(Checkbox, { checked: selected, onToggle: onClick, focussable: 'off' }), _jsx("div", { className: `childContainer ${childDirection}`, children: children }), buttons] });
};
